<template>
  <div style="background-color:#f4f4f4;">
    <navCom :navActive="navActive"></navCom>
    <!-- 列表页 start -->
    <div class="list-main">
      <!-- 列表页筛选 start -->
      <div class="list-main-screen">
        <div class="filter-item-box">
          <!-- 一级分类 start -->
          <div class="grade-box">
            <div class="title"><i><img src="../../static/images/zmr-images/grade-icon.png" width="18px"></i>分类：</div>
            <ul class="filter-item-list" :style="{height: switchOpen.grade ? '39px':'auto'}">
              <li v-for="Item in type" :class="{active:filterCur.gradeCurrent == Item.id }"
                  @click="filterClick('grade',Item.id)">{{Item.title}}
              </li>
            </ul>
            <span class="is-open" @click="isOpenFun('grade')">{{switchOpen.grade ? '展开' : '收起'}} <i
              :class="switchOpen.grade ? '' : 'icon'"><img src="../../static/images/zmr-images/open-icon.png"
                                                           width="100%"></i></span>
          </div>
          <!-- 一级分类 end -->
          <!-- 二级分类 start -->
          <div class="grade-box">
            <div class="title">
              <i><img src="../../static/images/zmr-images/subject-icon.png" width="18px"></i>
              二级分类：
            </div>
            <ul class="filter-item-list" :style="{height: switchOpen.subject ? '39px':'auto'}">
              <li v-for="(Item,index) in secondTitle" :class="{active : filterCur.subjectCurrent == index}"
                  @click="filterClick('subject',index,Item.id)">{{Item.title}}
              </li>
            </ul>
            <span class="is-open" @click="isOpenFun('subject')">
              {{switchOpen.subject ? '展开' : '收起'}}
              <i :class="switchOpen.subject ? '' : 'icon'">
                <img src="../../static/images/zmr-images/open-icon.png" width="100%">
              </i>
            </span>
          </div>
          <!-- 二级分类 end -->
        </div>
      </div>
      <!-- 列表页筛选 end -->
      <!-- 列表项 start -->
      <div class="list-item-box" v-if="list.length > 0">
        <ul class="list-item-ul">
          <li v-for="(item,index) of list" :key="index">
            <div class="list-item-li-left">
              <div class="list-item-course-img"><img :src="item.course_pic" :onerror="errorImg01" width="100%"></div>
              <div class="list-item-title">
                <h3 class="list-item-title-txt">{{item.course_name}}</h3>
                <p class="course-label">
                  <span v-for="(iteml,i) of item.course_label" :key="i" v-show="iteml.a!=null">{{iteml.a}}</span>
                </p>
                <div class="course-content">
                  <p class="course-content-txt"><i class="course-content-icon">
                    <img src="../../static/images/zmr-images/video.png" width="100%"></i>共{{item.video_num}}个视频</p>
                  <p class="course-content-txt">
                    <i class="course-content-icon">
                      <img src="../../static/images/zmr-images/note.png" width="100%">
                    </i>
                    <span>共约<span v-show="item.total_time/60 >=60">{{ parseInt(item.total_time/360)}}小时</span><span v-if="item.total_time>=60&&item.total_time/60 >=60">{{parseInt(item.total_time/60%60)}}分钟</span><span v-if="item.total_time>=60">{{parseInt(item.total_time/60)}}分钟</span><span v-show="item.total_time%60!=0">{{parseInt(item.total_time%60)}}秒</span></span>
                    <span v-show="item.total_time==''">0小时</span>
                  </p>
                </div>
                <div class="course-price">
                  <span class="present-price">￥{{item.preferential_price}}</span>
                  <span class="original-price">原价：{{item.original_price}}</span>
                </div>
              </div>
            </div>
            <p class="list-item-li-right">
              <a onclick="window.open('tencent://message/?uin=291235126');" href="javascript:;" class="online-ask-btn">在线咨询</a>
              <a href="javascript:;" class="course-detail-btn" @click="courseDetailFun(item.id)">课程详情</a>
            </p>
          </li>
        </ul>
      </div>
      <!-- 列表项 end -->
    </div>
    <!-- 分页 start-->
    <page-com :last_page="last_page" :total="total" :display='display' @pagechange="getOnline"
              :current-page='current_page' v-if="list.length > 0" style="margin-top: 40px;"></page-com>
    <!-- 分页 end-->
    <footerCom></footerCom>
  </div>
</template>
<script>
  import navCom from '../components/welcome-nav'
  import footerCom from '../components/foot'
  import pageCom from './components/page-com'
  import list_detail from './list-detail'
  import tool from '../assets/js/tool'

  export default {
    name: "list",
    components: {
      navCom,
      footerCom,
      pageCom,
    },
    data() {
      return {
        errorImg01: 'this.src="' + require('../../static/images/zmr-images/default.jpg') + '"',
        noDataFlag: 0,//无数据标识 0:有数据 1无数据
        total: 10,     // 记录总条数
        display: 10,   // 每页显示条数
        current_page: 1,   // 当前的页数
        last_page: 5,//总页数
        navActive: 1, //当前导航
        isOpenTxt: '展开',
        list: Object,//线上课列表
        type: Array,//课程一级分类
        secondTitle: Array,//二级分类标题
        // course_type:this.$route.query.id,//分类id
        switchOpen: {
          grade: true,
          subject: true,
          region: true,
        }, //判断收起展开
        filterCur: {
          gradeCurrent: 1,//年级导航
          subjectCurrent: 0,//学科导航
        },
      }
    },
    computed: {},
    watch: {},
    methods: {
      isOpenFun(num) {
        if (num == 'grade') {
          this.switchOpen.grade = !this.switchOpen.grade
        } else if (num == 'subject') {
          this.switchOpen.subject = !this.switchOpen.subject
        } else if (num == 'region') {
          this.switchOpen.region = !this.switchOpen.region
        }
      }, //展开
      //筛选点击事件
      filterClick: function (who, id, item) {
        this.filterCur.subjectCurrent = 0;
        switch (who) {
          case 'grade':
            this.filterCur.gradeCurrent = id;
            break;
          case 'subject':
            this.filterCur.subjectCurrent = id;
            break;
          default:
        }
        let data = {
          user_id: this.$store.state.uuid,
          parent_id: this.filterCur.gradeCurrent,
          child_id: item
        };
        tool.postData('Course_Online/index', data, (res) => {//线上课列表
          this.list = res.data.data.list.data;
          this.type = res.data.data.type;
          this.secondTitle = res.data.data.child_type;
          this.total = Number(res.data.data.list.total);
          this.display = Number(res.data.data.list.per_page);
          this.last_page = Number(res.data.data.list.last_page);
          this.current_page = Number(res.data.data.list.current_page);
          if (res.data.data.list.data.length > 0) {
            this.noDataFlag = 0;
          } else {
            this.noDataFlag = 1;
          }
        })
      },
      courseDetailFun(id) {
        this.$router.push({
          name: 'list-detail',
          component: list_detail,
          query: {
            course_id: id
          }
        });
      }, //进入详情页
      getOnline(currentPage) {
        let data = {
          user_id: this.$store.state.uuid,
          parent_id: this.$route.query.parent_id,
          child_id: this.filterCur.subjectCurrent,
          page: currentPage
        };
        this.filterCur.gradeCurrent = this.$route.query.parent_id;
        tool.postData('Course_Online/index', data, (res) => {//线上课列表
          this.list = res.data.data.list.data;
          this.type = res.data.data.type;
          this.secondTitle = res.data.data.child_type;
          this.total = Number(res.data.data.list.total);
          this.display = Number(res.data.data.list.per_page);
          this.last_page = Number(res.data.data.list.last_page);
          this.current_page = Number(res.data.data.list.current_page);
          if (res.data.data.list.data.length > 0) {
            this.noDataFlag = 0;
          } else {
            this.noDataFlag = 1;
          }
        })
      },
    },
    mounted: function () {
      if (this.navCurrent > 99) {
        this.$store.commit("changeNav", this.navCurrent - 100);
      }
      this.getOnline();
    },
  }
</script>

<style scoped>
  .list-main {
    width: 1220px;
    margin: 20px auto 0;
  }

  .filter-item-box {
    width: 100%;
    border: 1px solid #c9c9c9;
    padding: 17px;
    box-sizing: border-box;
    border-radius: 7px;
    background: #fff;
  }

  .grade-box {
    border-bottom: 1px solid #e3e3e3;
    padding: 15px 0 13px;
    box-sizing: border-box;
  }

  .grade-box:last-child {
    border: none;
  }

  .grade-box .title {
    font-size: 16px;
    color: #1a71ff;
    display: inline-block;
    vertical-align: top;
    position: relative;
    top: 10px;
  }

  .grade-box .title i {
    width: 18px;
    display: inline-block;
    margin-right: 10px;
  }

  .filter-item-list {
    display: inline-block;
    width: 1000px;
    height: 39px;
    overflow: hidden;
  }

  .filter-item-list li {
    padding: 10px 19px;
    box-sizing: border-box;
    display: inline-block;
    cursor: pointer;
    font-size: 16px;
    color: #696969;
  }

  .filter-item-list li.active {
    background: #1a71ff;
    border-radius: 5px;
    color: #fff;
  }

  .is-open {
    float: right;
    color: #2d2d2d;
    font-size: 16px;
    vertical-align: top;
    position: relative;
    top: 10px;
    cursor: pointer;
  }

  .is-open i {
    width: 14px;
    display: inline-block;
  }

  .is-open .icon {
    transform: rotate(180deg);
  }

  .list-item-box {
    border: 1px solid #c9c9c9;
    margin-top: 36px;
    background: #fff;
    border-radius: 7px;
    overflow: hidden;
  }

  .list-item-top {
    border-bottom: 1px solid #c9c9c9;
  }

  .list-item-top span {
    padding: 0 19px;
    line-height: 50px;
    font-size: 16px;
    color: #747474;
    border-right: 1px solid #c9c9c9;
    cursor: pointer;
  }

  .list-item-top span.active {
    color: #1a71ff
  }

  .list-item-top span:last-child {
    border-right: none;
  }

  .list-item-top span i {
    width: 12px;
    display: inline-block;
    font-size: 18px;
    vertical-align: top;
  }

  .list-item-top span.active {
    color: #1a71ff;
  }

  .list-item-ul {
    padding-bottom: 10px;
    box-sizing: border-box;
    background: #fff;
  }

  .list-item-ul > li {
    position: relative;
    border-bottom: 1px solid #c9c9c9;
    padding: 44px 15px;
    box-sizing: border-box;
  }

  .list-item-ul > li:last-child {
    border: none;
  }

  .list-item-li-left {
    width: 940px;
    display: inline-block;
  }

  .list-item-course-img {
    width: 303px;
    height: 230px;
    display: inline-block;
    position: relative;
  }

  .list-item-course-img img {
    height: 100%;
  }

  .list-item-course-img img:after {
    display: block;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
  }

  .list-item-title {
    display: inline-block;
    vertical-align: top;
    margin-left: 32px;
  }

  .list-item-title-txt {
    font-size: 22px;
    color: #414141;
    font-weight: bold;
    margin: 23px 0 15px;
  }

  .list-item-course-detail span {
    margin-right: 30px;
    color: #888;
    font-size: 16px;
  }

  .list-item-course-detail span i {
    display: inline-block;
    vertical-align: bottom;
    margin-right: 10px;
  }

  .list-item-course-teacher li {
    margin-right: 25px;
    padding: 20px 0;
    box-sizing: border-box;
    display: inline-block;
  }

  .list-item-course-teacher li span {
    margin-right: 10px;
    width: 25px;
    height: 25px;
    display: inline-block;
    border-radius: 50%;
    overflow: hidden;
    vertical-align: middle;
  }

  .list-item-course-teacher li p {
    display: inline-block;
    color: #888;
    font-size: 16px;
  }

  .present-price {
    font-size: 24px;
    color: #ce0000;
    line-height: 0;
    font-weight: bold;
  }

  .original-price {
    font-size: 12px;
    color: #999;
    vertical-align: bottom;
    text-decoration: line-through;
    line-height: 14px;
    margin-left: 10px;
  }

  .surplus-number {
    font-weight: bold;
    color: #ce0000;
  }

  .list-item-li-right {
    width: 150px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translate(0, -50%);
  }

  .list-item-li-right a {
    display: block;
    font-size: 20px;
    text-align: center;
    height: 45px;
    line-height: 45px;
    border-radius: 5px;
  }

  .online-ask-btn {
    border: 2px solid #2ea6a5;
    color: #2ea6a5;
  }

  .course-detail-btn {
    border: 2px solid #ff9919;
    color: #ff9919;
    margin-top: 25px;
  }

  .course-label {
    margin-bottom: 10px;
  }

  .course-content {
    display: flex;
    margin-bottom: 25px;
  }

  .course-content-txt {
    font-size: 14px;
    color: #888888;
    margin-bottom: 8px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right: 30px;
  }

  .course-content-icon {
    width: 12px;
    display: inline-block;
    vertical-align: text-top;
    margin-right: 14px;
  }

  .course-label span {
    padding: 0 15px;
    box-sizing: border-box;
    font-size: 14px;
    border-radius: 20px;
    margin: 10px 7px 14px 0;
    display: inline-block;
    line-height: 23px;
  }

  .course-label span:nth-child(n) {
    color: #e60012;
    border: 1px solid #e60012;
  }

  .course-label span:nth-child(2n) {
    color: #2996e2;
    border: 1px solid #2996e2;
  }

  .course-label span:nth-child(3n) {
    color: #ff8e00;
    border: 1px solid #ff8e00;
  }

  .course-label span:nth-child(4n) {
    color: #2ea6a5;
    border: 1px solid #2ea6a5;
  }
</style>













// WEBPACK FOOTER //
// src/pages/online_class.vue